/* Magic Makeup - Barra de beneficios #MagicDays (carrito lateral, pagina de carrito y ficha de producto)
   Para cambiar montos o textos, edita solo el arreglo TIERS (montos en pesos).
   Los montos se calculan sobre el total del carrito CON los codigos de descuento aplicados
   (igual que Shopify calcula el envio GRATIS y AppHero los REGALOS).
   Regla de marca: las palabras REGALO y GRATIS van siempre en mayusculas. */
(function () {
  if (window.mmProgressBarLoaded) return;
  window.mmProgressBarLoaded = true;

  var TIERS = [
    { amount: 29990, icon: '🚚', short: 'Envío GRATIS<br>RM', next: 'envío GRATIS en la RM', done: 'Ya tienes envío GRATIS en la RM 🚚' },
    { amount: 39990, icon: '🎁', short: 'REGALO<br>sorpresa', next: 'tu REGALO sorpresa', done: 'Ya tienes tu REGALO sorpresa 🎁' },
    { amount: 59990, icon: '🚚🇨🇱', short: 'Envío GRATIS<br>Chile', next: 'envío GRATIS a todo Chile', done: 'Ya tienes envío GRATIS a todo Chile 🚚🇨🇱' },
    { amount: 79990, icon: '💎', short: 'Limpiador travel<br>de REGALO', next: 'tu limpiador travel size de REGALO', done: 'Ya tienes tu limpiador travel size de REGALO 💎' }
  ];
  var ALL_DONE = '🤩 ¡Desbloqueaste todos los beneficios #MagicDays!';

  var script = document.currentScript;
  var total = script && script.dataset.total !== undefined ? Number(script.dataset.total) / 100 : null;
  var codes = [];          // codigos de descuento del carrito [{code, applicable}]
  var codeMsg = '';        // mensaje temporal del formulario de codigo
  var codeMsgType = '';
  var busy = false;
  var cartProducts = [];   // product_id de lo que ya esta en el carrito
  var upPool = [];         // productos que se pueden sugerir (todo el catalogo disponible)
  var UP_COLLECTION = 'oh-so-clean'; // coleccion "Todo Magic Makeup" (Cyber)
  var wideMQ = window.matchMedia('(min-width: 1000px)'); // mismo corte "computador" que usa el tema (lap-and-up)
  var pageType = (window.themeVariables && window.themeVariables.settings && window.themeVariables.settings.pageType) || '';

  function fmt(n) {
    return '$' + String(Math.max(0, Math.round(n))).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }
  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; });
  }

  function percent(t) {
    var n = TIERS.length, step = 100 / n;
    if (t >= TIERS[n - 1].amount) return 100;
    for (var i = 0; i < n; i++) {
      if (t < TIERS[i].amount) {
        var prev = i === 0 ? 0 : TIERS[i - 1].amount;
        var frac = (t - prev) / (TIERS[i].amount - prev);
        var start = i === 0 ? 0 : step / 2 + (i - 1) * step;
        var span = i === 0 ? step / 2 : step;
        return start + frac * span;
      }
    }
    return 100;
  }

  function message(t) {
    var next = null, achieved = null;
    for (var i = 0; i < TIERS.length; i++) {
      if (t >= TIERS[i].amount) achieved = TIERS[i];
      else if (!next) next = TIERS[i];
    }
    if (!next) return ALL_DONE;
    var msg = 'Te faltan <strong>' + fmt(next.amount - t) + '</strong> para ' + next.next + ' ' + next.icon;
    if (achieved) msg = '<span class="mm-pb__ok">' + achieved.done + '</span> ' + msg;
    return msg;
  }

  function activeCodes() {
    return codes.filter(function (c) { return c.applicable; });
  }

  function codeBlock() {
    var act = activeCodes();
    var html = '<div class="mm-pb__code">';
    if (act.length) {
      html += '<p class="mm-pb__applied">✓ Tu código <b>' + esc(act[0].code.toUpperCase()) + '</b> ha sido aplicado</p>';
    } else {
      // Sin campo para escribir codigos (decision Luli 2-oct: no recordar que existen codigos).
      // Solo se muestra el aviso cuando el codigo ya viene aplicado (p. ej. desde el link del mailing).
      if (!codeMsg) return '';
    }
    if (codeMsg) html += '<p class="mm-pb__codemsg mm-pb__codemsg--' + codeMsgType + '">' + codeMsg + '</p>';
    return html + '</div>';
  }

  // Sugerencias para llegar al siguiente beneficio: van DENTRO de la columna nativa del carrito lateral
  // ("Tambien te puede interesar"), con el mismo diseno del tema (decision Luli 4-oct: nada de recuadros extra).
  function upsellPicks() {
    if (total === null || !upPool.length) return null;
    var next = null;
    for (var i = 0; i < TIERS.length; i++) { if (total < TIERS[i].amount) { next = TIERS[i]; break; } }
    if (!next) return null;
    var gap = next.amount - total;
    var list = upPool.filter(function (p) { return cartProducts.indexOf(p.id) === -1; });
    // con un codigo aplicado (ej. MAGICVIP10) el producto suma ~10% menos: solo sugerimos lo que alcanza igual
    var f = activeCodes().length ? 0.9 : 1;
    // solo productos que por si solos completan el monto (decision Luli: acercarse no sirve, hay que llegar)
    var pick = list.filter(function (p) { return p.price * f >= gap; }).sort(function (a, b) { return a.price - b.price; }).slice(0, 3);
    return pick.length ? { next: next, pick: pick } : null;
  }

  function recCard(p) {
    var url = '/products/' + esc(p.handle);
    var price = p.compare > p.price
      ? '<span class="price price--highlight"><span class="visually-hidden">Precio de venta</span>' + fmt(p.price) + '</span><span class="price price--compare"><span class="visually-hidden">Precio normal</span>' + fmt(p.compare) + '</span>'
      : '<span class="price">' + fmt(p.price) + '</span>';
    return '<div class="product-item mm-up-item">' +
      '<div class="product-item__image-wrapper"><a href="' + url + '" class="product-item__aspect-ratio aspect-ratio" style="padding-bottom:100%;--aspect-ratio:1">' +
      (p.img ? '<img src="' + esc(p.img) + '" alt="" loading="lazy" class="product-item__primary-image">' : '') + '</a></div>' +
      '<div class="product-item__info text--small"><div class="product-item-meta">' +
      '<a href="' + url + '" class="product-item-meta__title">' + esc(p.title) + '</a>' +
      '<div class="product-item-meta__price-list-container"><div class="price-list price-list--centered">' + price + '</div></div></div>' +
      '<div class="product-item__cta-wrapper"><button type="button" class="product-item__link link text--subdued" data-mm-add="' + p.variant + '">Añadir al carrito</button></div>' +
      '</div></div>';
  }

  function decorateRecs() {
    var box = document.querySelector('cart-drawer-recommendations .mini-cart__recommendations-list');
    if (!box) return;
    var res = upsellPicks();
    var sig = res ? res.next.amount + ':' + res.pick.map(function (p) { return p.id; }).join(',') : 'none';
    if (box.getAttribute('data-mm-sig') === sig) return;
    box.setAttribute('data-mm-sig', sig);
    box.querySelectorAll('.mm-up-item').forEach(function (e) { e.remove(); });
    box.querySelectorAll('.mm-dup').forEach(function (e) { e.classList.remove('mm-dup'); });
    var label = res ? 'Súmale uno y llegas a ' + res.next.short.replace(/<br>/g, ' ') + ' ' + res.next.icon : null;
    document.querySelectorAll('cart-drawer-recommendations .mini-cart__recommendations-heading').forEach(function (h) {
      if (!h.hasAttribute('data-mm-orig')) h.setAttribute('data-mm-orig', h.textContent);
      var t = label || h.getAttribute('data-mm-orig');
      if (h.textContent !== t) h.textContent = t;
    });
    if (!res) return;
    var handles = res.pick.map(function (p) { return p.handle; });
    box.querySelectorAll('.product-item').forEach(function (it) {
      var a = it.querySelector('a[href*="/products/"]');
      var h = a ? decodeURIComponent(a.getAttribute('href').split('/products/')[1].split('?')[0]) : '';
      if (handles.indexOf(h) > -1) it.classList.add('mm-dup'); // no repetir el mismo producto dos veces
    });
    box.insertAdjacentHTML('afterbegin', res.pick.map(recCard).join(''));
  }

  // Resumen de descuentos de codigos que aplican a productos (ej. LIMPIADOR10) en el pie del carrito lateral,
  // con el mismo formato que el tema usa para los codigos de pedido (ej. CONSUELOROJAS20 -$X). Decision Luli 4-oct.
  var lastCart = null;
  var DISC_ICON = '<svg focusable="false" width="10" height="10" class="icon icon--discount-badge" viewBox="0 0 10 10"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.93734 1.1171C9.97075 0.521457 9.47854 0.0292498 8.88291 0.0626607L5.39562 0.258271C5.15016 0.27204 4.91836 0.375751 4.74452 0.549595L0.707107 4.58701C0.316582 4.97753 0.316583 5.6107 0.707107 6.00122L3.99878 9.29289C4.3893 9.68342 5.02247 9.68342 5.41299 9.29289L9.4504 5.25548C9.62425 5.08163 9.72796 4.84984 9.74173 4.60438L9.93734 1.1171ZM7.05882 2.94118C7.3837 3.26605 7.91042 3.26605 8.23529 2.94118C8.56017 2.6163 8.56017 2.08958 8.23529 1.76471C7.91042 1.43983 7.3837 1.43983 7.05882 1.76471C6.73395 2.08958 6.73395 2.6163 7.05882 2.94118Z" fill="currentColor"></path></svg>';
  function footerDiscounts() {
    var f = document.querySelector('#mini-cart .mini-cart__drawer-footer');
    if (!f || !lastCart) return;
    var sums = {}, order = [];
    (lastCart.items || []).forEach(function (it) {
      (it.line_level_discount_allocations || []).forEach(function (a) {
        var app = a.discount_application || {};
        if (app.type !== 'discount_code') return;
        var t = app.title || app.key || 'Descuento';
        if (!(t in sums)) { sums[t] = 0; order.push(t); }
        sums[t] += a.amount;
      });
    });
    var sig = order.map(function (t) { return t + ':' + sums[t]; }).join('|');
    var mine = f.querySelector(':scope > .mm-disc');
    if (mine && mine.getAttribute('data-sig') === sig) return;
    if (mine) mine.remove();
    if (!order.length) return;
    var html = order.map(function (t) {
      return '<li class="mini-cart__discount"><span class="mini-cart__discount-badge discount-badge">' + DISC_ICON + esc(t.toUpperCase()) + '</span> <span class="mini-cart__discount-price text--xsmall text--subdued">-' + fmt(sums[t] / 100) + '</span></li>';
    }).join('');
    var ul = document.createElement('ul');
    ul.className = 'mini-cart__discount-list list--unstyled mm-disc';
    ul.setAttribute('role', 'list');
    ul.setAttribute('data-sig', sig);
    ul.innerHTML = html;
    var nativeList = f.querySelector(':scope > .mini-cart__discount-list:not(.mm-disc)');
    if (nativeList) nativeList.insertAdjacentElement('afterend', ul); else f.insertBefore(ul, f.firstChild);
  }

  // Franja de confianza bajo "Anadir al carrito" en la ficha de producto (punto 2 conversion, 4-oct).
  // Sin borde arriba/abajo. Sin "Cambios hasta 30 dias" ni "Despacho RM" (decision Luli 4-oct). 3 items, icono arriba del texto.
  var WA_URL = 'https://wa.me/56952096787';
  function svgI(d) { return '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + d + '</svg>'; }
  var TRUST = [
    { icon: svgI('<path d="M12 21s-7-6.2-7-11.5A7 7 0 0 1 19 9.5C19 14.8 12 21 12 21z"/><circle cx="12" cy="9.5" r="2.5"/>'), text: 'Envío con<br>seguimiento' },
    { icon: svgI('<rect x="5" y="11" width="14" height="9" rx="1.5"/><path d="M8 11V8a4 4 0 0 1 8 0v3"/>'), text: 'Pago 100%<br>seguro' },
    { icon: svgI('<path d="M4 20l1.3-3.9A8 8 0 1 1 8 19z"/>'), text: '¿Dudas?<br><u class="mm-trust__link">WhatsApp</u>', href: WA_URL }
  ];
  function trustStrip() {
    if (pageType !== 'product') return;
    var buy = document.querySelector('.product__info .product-form__buy-buttons');
    if (!buy || document.querySelector('.product .mm-trust')) return;
    var html = TRUST.map(function (t) {
      var inner = '<span class="mm-trust__i">' + t.icon + '</span><span>' + t.text + '</span>';
      return t.href ? '<a class="mm-trust__item" href="' + t.href + '" target="_blank" rel="noopener">' + inner + '</a>' : '<div class="mm-trust__item">' + inner + '</div>';
    }).join('');
    buy.insertAdjacentHTML('afterend', '<div class="mm-trust">' + html + '</div>');
  }

  // Computador: la franja de confianza pasa a la columna izquierda, bajo las fotos, para llenar el espacio
  // en blanco (decision Luli 4-oct). Celular: queda bajo los botones.
  var rvHome = null;
  function leftColumn() {
    if (pageType !== 'product') return;
    var prod = document.querySelector('.product');
    var media = prod && prod.querySelector(':scope > .product__media');
    var buy = document.querySelector('.product__info .product-form__buy-buttons');
    if (!media || !buy) return;
    var left = prod.querySelector(':scope > .mm-left');
    var trust = prod.querySelector('.mm-trust');
    // La resena destacada de Loox queda a la derecha. En computador, "Complementa tu rutina" sube a la columna
    // izquierda bajo los iconos (antes quedaba sola y volando bajo la ficha). Decision Luli 4-oct.
    var rv = document.querySelector('.product-content__featured-products');
    if (rv && !rvHome && !(left && left.contains(rv))) rvHome = { parent: rv.parentNode, next: rv.nextSibling };
    if (wideMQ.matches) {
      if (!left) {
        left = document.createElement('div');
        left.className = 'mm-left';
        media.insertAdjacentElement('afterend', left);
      }
      var w = media.getBoundingClientRect().width;
      if (w && left.style.width !== Math.round(w) + 'px') left.style.width = Math.round(w) + 'px';
      if (trust && trust.parentNode !== left) left.insertBefore(trust, left.firstChild);
      if (rv && rv.parentNode !== left) { rv.classList.add('mm-rv'); left.appendChild(rv); }
    } else if (left) {
      if (trust) buy.insertAdjacentElement('afterend', trust);
      if (rv && rvHome && rvHome.parent.isConnected) {
        rv.classList.remove('mm-rv');
        rvHome.parent.insertBefore(rv, rvHome.next && rvHome.next.parentNode === rvHome.parent ? rvHome.next : null);
      }
      left.remove();
    }
  }

  // Producto sin resenas en Loox (data-raters vacio): se ocultan la seccion de resenas (iframe vacio de 144px)
  // y el bloque de resena destacada, en computador y celular (decision Luli 4-oct).
  function hideEmptyLoox() {
    if (pageType !== 'product') return;
    var r = document.querySelector('.product__info .loox-rating[data-raters]');
    if (!r) return;
    var n = parseInt(r.getAttribute('data-raters') || '0', 10);
    if (n > 0) return;
    var lr = document.getElementById('looxReviews');
    var sec = lr && lr.closest('.shopify-section');
    if (sec && !sec.hidden) sec.hidden = true;
    document.querySelectorAll('.product__info .shopify-app-block[id*="loox_snippets"]').forEach(function (b) { if (!b.hidden) b.hidden = true; });
  }

  var estHTML = null;
  function loadEstimator() {
    estHTML = '';
    fetch('/cart', { headers: { 'Accept': 'text/html' } })
      .then(function (r) { return r.text(); })
      .then(function (h) {
        var d = new DOMParser().parseFromString(h, 'text/html');
        var e = d.querySelector('.cart__content .shipping-estimator');
        if (e) { estHTML = e.outerHTML; place(); }
      })
      .catch(function () {});
  }

  function loadUpsell() {
    fetch('/collections/' + UP_COLLECTION + '/products.json?limit=250', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        upPool = (d.products || []).map(function (p) {
          var v = (p.variants || []).filter(function (x) { return x.available; })[0];
          if (!v) return null;
          var price = Math.round(Number(v.price));
          if (!(price > 0)) return null;
          var src = p.images && p.images[0] && p.images[0].src;
          return {
            id: p.id, handle: p.handle, variant: v.id, price: price, compare: Math.round(Number(v.compare_at_price || 0)),
            title: String(p.title).replace(/^\s*NUEVO!?\s*/i, '').replace(/[✭✨]/g, '').replace(/\s+/g, ' ').trim(),
            img: src ? src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=300' : ''
          };
        }).filter(Boolean);
        renderAll();
      })
      .catch(function () {});
  }

  function addUpsell(btn) {
    if (busy) return;
    busy = true;
    btn.disabled = true; btn.textContent = 'Agregando…';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(btn.getAttribute('data-mm-add')), quantity: 1 }] })
    })
      .then(function () { return getCart(); })
      .then(function (c) { busy = false; setCart(c); notifyCartChanged(c); })
      .catch(function () { busy = false; btn.disabled = false; btn.textContent = 'Añadir al carrito'; });
  }

  function render(el) {
    if (total === null) { el.hidden = true; return; }
    el.hidden = false;
    // conserva lo que la persona esta escribiendo si se vuelve a dibujar
    var typing = el.querySelector('.mm-pb__input');
    var typed = typing ? typing.value : '';
    var hadFocus = typing && document.activeElement === typing;
    var n = TIERS.length, step = 100 / n, dots = '', labels = '';
    for (var i = 0; i < n; i++) {
      var done = total >= TIERS[i].amount ? ' is-done' : '';
      dots += '<span class="mm-pb__dot' + done + '" style="left:' + (step / 2 + i * step) + '%"></span>';
      labels += '<span class="mm-pb__label' + done + '"><i>' + TIERS[i].icon + '</i><b>' + TIERS[i].short + '</b>' + fmt(TIERS[i].amount) + '</span>';
    }
    el.innerHTML =
      '<p class="mm-pb__msg">' + message(total) + '</p>' +
      '<div class="mm-pb__track"><div class="mm-pb__fill" style="width:' + percent(total) + '%"></div>' + dots + '</div>' +
      '<div class="mm-pb__labels">' + labels + '</div>' +
      (el.classList.contains('mm-pb--product') ? '' : codeBlock());
    var input = el.querySelector('.mm-pb__input');
    if (input && typed) input.value = typed;
    if (input && hadFocus) input.focus();
  }

  function make(extraClass) {
    var el = document.createElement('div');
    el.className = 'mm-pb ' + (extraClass || '');
    render(el);
    return el;
  }

  function place() {
    tweakEstimator();
    // Algunas paginas usan una version del logo de Jumbo con mucho margen (4_jumbo_gris_sm): se cambia por la normal
    document.querySelectorAll('.logo-list img[src*="4_jumbo_gris_sm"]').forEach(function (im) {
      im.removeAttribute('srcset');
      im.src = im.src.replace('4_jumbo_gris_sm', '4_jumbo_gris');
    });
    if (pageType === 'product') {
      // Estrellas de Loox justo bajo el titulo (el tema no permite bloques entre titulo y precio)
      var pTitle = document.querySelector('.product__info .product-meta__title');
      var stars = document.querySelector('.product__info .shopify-app-block[id*="loox_rating"]');
      if (pTitle && stars && pTitle.nextElementSibling !== stars) pTitle.insertAdjacentElement('afterend', stars);
      var meta = document.querySelector('.product__info product-meta');
      if (meta && !(meta.nextElementSibling && meta.nextElementSibling.classList.contains('mm-pb'))) {
        meta.insertAdjacentElement('afterend', make('mm-pb--product'));
      }
    }
    if (pageType === 'cart') {
      var header = document.querySelector('.page-header__text-wrapper');
      if (header && !header.querySelector('.mm-pb')) header.appendChild(make('mm-pb--cart'));
    }
    var drawer = document.querySelector('#mini-cart .drawer__content');
    if (drawer && !drawer.classList.contains('drawer__content--center')) {
      // Computador: barra ARRIBA de los productos (que no quede escondida).
      // Celular: barra DESPUES de los productos (primero lo que compro). Decision Luli 4-oct.
      var items = drawer.querySelector(':scope > form');
      var bar = drawer.querySelector(':scope > .mm-pb');
      if (!bar) bar = make('mm-pb--drawer');
      if (wideMQ.matches || !items) {
        if (drawer.firstElementChild !== bar) drawer.insertBefore(bar, drawer.firstChild);
      } else if (items.nextElementSibling !== bar) {
        items.insertAdjacentElement('afterend', bar);
      }
      // Estimacion de envio (la misma de la pagina de carrito) al final: despues de los productos y de la barra
      if (pageType !== 'cart' && estHTML) {
        var anchor = (wideMQ.matches && items) ? items : bar;
        if (!(anchor.nextElementSibling && anchor.nextElementSibling.classList.contains('mm-est'))) {
          var old = drawer.querySelector(':scope > .mm-est');
          if (old) anchor.insertAdjacentElement('afterend', old);
          else anchor.insertAdjacentHTML('afterend', '<div class="mm-est">' + estHTML + '</div>');
        }
      }
    }
    decorateRecs();
    footerDiscounts();
    trustStrip();
    leftColumn();
    hideEmptyLoox();
  }

  // Estimador de envio del carrito (nativo de Focal): en Chile no se usa codigo postal y solo despachamos a Chile.
  // Se ocultan pais y codigo postal y "Provincia" pasa a "Región". Las tarifas siguen siendo las de Shopify (por region).
  function tweakEstimator() {
    var zip = document.getElementById('shipping-estimator[zip]');
    if (zip && zip.closest('.input')) zip.closest('.input').style.display = 'none';
    var country = document.getElementById('shipping-estimator[country]');
    if (country && country.closest('.input')) country.closest('.input').style.display = 'none';
    var label = document.querySelector('label[for="shipping-estimator[province]"]');
    if (label && label.textContent !== 'Región') label.textContent = 'Región';
    tweakPayments();
  }

  // Medios de pago bajo "Ir a pagar" (pagina de carrito) y en el footer: en vez del texto "Aceptamos",
  // logos de Webpay (Transbank), Mercado Pago y VentiPay antes de los logos de tarjetas.
  var PAY_LOGOS = [['mm-pay-webpay.svg', 'Webpay (Transbank)'], ['mm-pay-mercadopago.svg', 'Mercado Pago'], ['mm-pay-ventipay.svg', 'VentiPay']];
  function tweakPayments() {
    document.querySelectorAll('.cart__payment-methods, .footer__payment-methods').forEach(tweakPayBox);
  }
  function tweakPayBox(box) {
    if (box.dataset.mmPay) return;
    box.dataset.mmPay = '1';
    var lbl = box.querySelector('.cart__payment-methods-label, .footer__payment-methods-label');
    if (lbl) lbl.style.display = 'none';
    var list = box.querySelector('.payment-methods-list');
    if (!list || !script || !script.src) return;
    // Amex y Diners fuera (decision Luli: en Chile casi no se usan)
    list.querySelectorAll('svg').forEach(function (s) {
      var t = s.querySelector('title');
      if (t && /american express|diners/i.test(t.textContent)) s.remove();
    });
    var base = script.src.replace(/mm-progress-bar\.js.*$/, '');
    PAY_LOGOS.slice().reverse().forEach(function (p) {
      var img = document.createElement('img');
      img.src = base + p[0] + '?v=2'; // subir el numero si se cambia un logo (cache del CDN)
      img.alt = p[1];
      img.title = p[1];
      img.width = 38;
      img.height = 24;
      img.className = 'icon icon--full-color';
      list.insertBefore(img, list.firstChild);
    });
  }

  function renderAll() {
    document.querySelectorAll('.mm-pb').forEach(render);
    decorateRecs();
  }

  function setCart(c) {
    total = Number(c.total_price) / 100;
    lastCart = c;
    codes = (c.discount_codes || []).map(function (d) { return { code: d.code, applicable: !!d.applicable }; });
    cartProducts = (c.items || []).map(function (it) { return it.product_id; });
    place();
    renderAll();
  }

  function setTotal(cents) {
    total = Number(cents) / 100;
    place();
    renderAll();
  }

  function getCart() {
    return fetch('/cart.js', { cache: 'no-store', headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
  }

  var refreshTimer;
  function refresh() {
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(function () {
      getCart().then(setCart).catch(function () {});
    }, 250);
  }

  // Avisa al tema (lineas y totales del carrito) y a AppHero (REGALOS) que el carrito cambio.
  function notifyCartChanged(cart) {
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart: cart } }));
    if (pageType === 'cart') {
      // en la pagina de carrito recargamos para que todo (precios por linea y REGALOS) quede recalculado
      setTimeout(function () { window.location.reload(); }, 900);
    }
  }

  function updateDiscount(code) {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ discount: code })
    }).then(function (r) { return r.json(); });
  }

  function applyCode(raw) {
    var code = String(raw || '').trim();
    if (!code || busy) return;
    busy = true; codeMsg = ''; renderAll();
    updateDiscount(code)
      .then(function () { return getCart(); })
      .then(function (c) {
        busy = false;
        var found = (c.discount_codes || []).filter(function (d) { return d.code.toLowerCase() === code.toLowerCase(); })[0];
        if (found && found.applicable) {
          codeMsg = ''; setCart(c); notifyCartChanged(c);
        } else {
          // codigo invalido o que no aplica a este carrito: lo sacamos para no dejar basura en el carrito
          codeMsg = 'Este código no es válido o no aplica a los productos de tu carrito.';
          codeMsgType = 'error';
          return updateDiscount('').then(function () { return getCart(); }).then(setCart);
        }
      })
      .catch(function () {
        busy = false; codeMsg = 'No pudimos aplicar el código. Inténtalo de nuevo.'; codeMsgType = 'error'; renderAll();
      });
  }

  function removeCode() {
    if (busy) return;
    busy = true; codeMsg = ''; renderAll();
    updateDiscount('')
      .then(function () { return getCart(); })
      .then(function (c) { busy = false; setCart(c); notifyCartChanged(c); })
      .catch(function () { busy = false; renderAll(); });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest && e.target.closest('[data-mm-code-form]');
    if (!form) return;
    e.preventDefault();
    applyCode(form.querySelector('.mm-pb__input').value);
  });
  document.addEventListener('click', function (e) {
    var addBtn = e.target.closest && e.target.closest('[data-mm-add]');
    if (addBtn) { e.preventDefault(); addUpsell(addBtn); return; }
    if (e.target.closest && e.target.closest('[data-mm-remove]')) { e.preventDefault(); removeCode(); }
  });

  var style = document.createElement('style');
  style.textContent =
    '.mm-pb{margin:16px 0 20px;padding:12px 10px 10px;background:#f9eff7;border-radius:8px;color:#1a1a1a;font-size:13px;line-height:1.35}' +
    '.mm-pb[hidden]{display:none}' +
    '.mm-pb--drawer{margin:16px 0 20px}' +
    '.mm-pb--cart{margin:16px auto 0;max-width:560px}' +
    '.mm-pb__msg{margin:0 0 12px;text-align:center}' +
    '.mm-pb__msg strong{color:#ac0078}' +
    '.mm-pb__ok{display:block;color:#ac0078;font-weight:600;font-size:12px;margin-bottom:2px}' +
    '.mm-pb__track{position:relative;height:6px;background:#fff;border-radius:999px}' +
    '.mm-pb__fill{position:absolute;left:0;top:0;bottom:0;background:#ac0078;border-radius:999px;transition:width .6s ease}' +
    '.mm-pb__dot{position:absolute;top:50%;width:14px;height:14px;margin:-7px 0 0 -7px;border-radius:50%;background:#fff;border:2px solid #ebadd6;box-sizing:border-box;transition:background .3s,border-color .3s}' +
    '.mm-pb__dot.is-done{background:#ac0078;border-color:#ac0078}' +
    '.mm-pb__labels{display:grid;grid-template-columns:repeat(4,1fr);column-gap:4px;margin-top:8px;text-align:center;font-size:11px;line-height:1.25;color:#6b6b6b}' +
    '.mm-pb__labels i{display:block;font-style:normal;font-size:13px;margin-bottom:1px}' +
    '.mm-pb__labels b{display:block;font-weight:600;color:#1a1a1a;margin-bottom:1px}' +
    '.mm-pb__label.is-done,.mm-pb__label.is-done b{color:#ac0078}' +
    '@media (max-width:400px){.mm-pb__labels{font-size:10.5px;column-gap:2px}.mm-pb__labels b{white-space:nowrap}}' +
    '.mm-dup{display:none!important}' +
    // Menu de arriba: "Cyber" en amarillo (decision Luli 4-oct). Solo en la barra negra del computador.
    '.header__linklist-link[href=\"/collections/oh-so-clean\"]{color:#ffd400!important;font-weight:600}' +
    '.mm-trust{display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:12px 16px;margin:28px 0 24px}' +
    '.mm-trust__item{display:flex;flex-direction:column;align-items:center;text-align:center;gap:6px;font-size:13px;line-height:1.3;color:#1a1a1a;text-decoration:none}' +
    '.mm-trust__item span:last-child{white-space:nowrap}.mm-trust__link{text-decoration:underline;text-underline-offset:2px}a.mm-trust__item:hover .mm-trust__link{color:#ac0078}' +
    '.mm-trust__i{flex:0 0 auto;display:flex;color:#ac0078}' +
    // Celular: estrellas, precio y cantidad centrados para que la pestana flotante de Resenas (Loox) no los tape,
    // y medallas mas grandes en la foto de la ficha (Luli 4-oct)
    '@media (max-width:740px){.product__info .product-meta__price-list-container{display:flex;justify-content:center}.product__info .product-meta__price-list-container .price-list{justify-content:center}.product__info .mm-pack-price{justify-items:center}.product__info .mm-pack-price__row,.product__info .mm-pack-price__main{justify-content:center}.product__info .product-form__quantity{display:flex;flex-direction:column;align-items:center}.product__info .loox-rating{display:flex;justify-content:center;text-align:center}.product-content__featured-products .mm-pack-card{justify-items:start;text-align:left}.mm-acc .mm-acc__toggle,.mm-acc .mm-acc__body{padding-left:32px}.product__media .mm-medals{top:10px;right:10px;gap:6px}.product__media .mm-medal{width:66px;height:66px;font-size:11.5px}.product__media .mm-medal--envio{font-size:9.5px}.product__media .mm-medal--2x1{font-size:18px}}' +
    '@media (min-width:1000px){.product:has(> .mm-left){display:grid;grid-template-columns:auto auto;grid-template-rows:auto 1fr;justify-content:space-between;align-items:start}.product:has(> .mm-left) > .product__media{grid-column:1;grid-row:1}.product > .mm-left{grid-column:1;grid-row:2}.product:has(> .mm-left) > .product__info{grid-column:2;grid-row:1 / span 2}.mm-left .mm-trust{grid-template-columns:repeat(3,max-content);justify-content:center;column-gap:48px;margin:40px 0 0}.mm-left .mm-rv{display:block;margin:64px 0 0!important;width:100%}.mm-left .mm-rv .product-content__featured-products-title{text-align:center}.mm-left .mm-rv .product-content__featured-products-list{grid-template-columns:repeat(auto-fit,minmax(0,190px))!important;justify-content:center!important;gap:24px!important}.shopify-section--product-content:not(:has(.product-content__featured-products)){display:none}}' +
    '.mm-est{margin:24px 0 20px}.mm-est .shipping-estimator{margin:0}.mm-disc{margin-bottom:8px}' +
    '.mm-pb__code{margin-top:12px;padding-top:10px;border-top:1px solid #ebd3e4}' +
    '.mm-pb__form{display:flex;gap:6px;margin:0}' +
    '.mm-pb__input{flex:1;min-width:0;height:36px;padding:0 10px;border:1px solid #e3c4da;border-radius:6px;background:#fff;font-size:13px;color:#1a1a1a;text-transform:uppercase}' +
    '.mm-pb__input::placeholder{text-transform:none;color:#9a8a95}' +
    '.mm-pb__input:focus{outline:none;border-color:#ac0078}' +
    '.mm-pb__apply{height:36px;padding:0 14px;border:0;border-radius:6px;background:#ac0078;color:#fff;font-size:13px;font-weight:600;cursor:pointer}' +
    '.mm-pb__apply[disabled]{opacity:.6;cursor:default}' +
    '.mm-pb__applied{margin:0;text-align:center;color:#ac0078;font-weight:600;font-size:12px}' +
    '.mm-pb__remove{background:none;border:0;padding:0;color:#6b6b6b;font-weight:400;font-size:12px;text-decoration:underline;cursor:pointer}' +
    '.mm-pb__note{margin:2px 0 0;text-align:center;color:#6b6b6b;font-size:11px}' +
    '.mm-pb__codemsg{margin:6px 0 0;text-align:center;font-size:11px}' +
    '.mm-pb__codemsg--error{color:#b3261e}' +
    // Total de la pagina de carrito con la misma tipografia que los demas montos (Figtree), no la de titulos
    '.cart__total-container .heading{font-family:var(--text-font-family);font-weight:var(--text-font-bold-weight);font-style:normal;letter-spacing:normal}' +
    // Logos "Encuentra una selección de nuestros productos en" al final de la ficha de producto (seccion mm_logo_list)
    '.product-meta__title + .shopify-app-block[id*="loox_rating"]{margin:6px 0 12px;font-size:13px}' +
    '.shopify-section--logo-list .section{padding-block:32px 72px;margin:0}' +
    '[id$="__custom_liquid_VGGVE8"] .section{margin:0}' +
    '.shopify-section--logo-list .container{max-width:900px}' +
    '.shopify-section--logo-list .section__header{padding-top:28px;border-top:1px solid rgba(26,26,26,.1)}' +
    // :is(...,#mm-x) sube la especificidad para ganarle al CSS personalizado de cada seccion (margin-bottom .4rem !important)
    ':is(.shopify-section--logo-list,#mm-x) :is(.section__header,#mm-y){margin-bottom:40px!important}' +
    '.shopify-section--logo-list .section__header .heading{font-size:11px;letter-spacing:.18em;color:rgba(26,26,26,.55)}' +
    '.shopify-section--logo-list .logo-list__list{display:flex!important;flex-wrap:wrap;justify-content:center;align-items:center;gap:20px 52px;grid-template-columns:none!important}' +
    '.shopify-section--logo-list .logo-list__item{width:auto!important;padding:0!important;background:none!important;border:0!important;min-height:0!important}' +
    // mismo gris para todos (filtro mm-logo-clean: quita el velo casi invisible del PNG de Mercado Libre) y peso visual parejo:
    // los logos llenos (Jumbo, Beauty F) mas suaves, Blush-Bar (trazo fino) mas oscuro. Orden intercalado liviano/pesado.
    '.shopify-section--logo-list .logo-list__item img{width:auto!important;object-fit:contain;mix-blend-mode:multiply;filter:grayscale(1) url(#mm-logo-clean);transition:opacity .2s}' +
    '.shopify-section--logo-list .logo-list__item img:hover{opacity:1!important}' +
    '.shopify-section--logo-list .logo-list__item:has(img[src*="blush-bar"]){order:1}.shopify-section--logo-list .logo-list__item:has(img[src*="mercadolibre"]){order:2}.shopify-section--logo-list .logo-list__item:has(img[src*="beauty-f"]){order:3}.shopify-section--logo-list .logo-list__item:has(img[src*="jumbo"]){order:4}' +
    '.shopify-section--logo-list img[src*="blush-bar"]{height:38px!important;max-width:180px!important;filter:grayscale(1) url(#mm-logo-clean) brightness(.7);opacity:.85}' +
    '.shopify-section--logo-list img[src*="beauty-f"]{height:38px!important;max-width:180px!important;opacity:.6}' +
    '.shopify-section--logo-list img[src*="mercadolibre"]{height:74px!important;max-width:140px!important;opacity:.85}' +
    '.shopify-section--logo-list img[src*="jumbo"]{height:74px!important;max-width:140px!important;opacity:.52}' +
    '@media (max-width:740px){:is(.shopify-section--logo-list,#mm-x) :is(.section__header,#mm-y){margin-bottom:28px!important}.shopify-section--logo-list .section__header .heading{font-size:10px;letter-spacing:.12em;padding-inline:8px}.shopify-section--logo-list .logo-list__list{display:grid!important;grid-template-columns:repeat(2,auto)!important;justify-content:center;justify-items:center;gap:22px 44px}.shopify-section--logo-list img[src*="blush-bar"],.shopify-section--logo-list img[src*="beauty-f"]{height:27px!important;max-width:128px!important}.shopify-section--logo-list img[src*="mercadolibre"],.shopify-section--logo-list img[src*="jumbo"]{height:54px!important}}';
  document.head.appendChild(style);
  // Filtro SVG para los logos "Encuentra una selección..." (ver estilos mm-logo-clean)
  document.body.insertAdjacentHTML('beforeend', '<svg width="0" height="0" style="position:absolute" aria-hidden="true" focusable="false"><filter id="mm-logo-clean" color-interpolation-filters="sRGB"><feComponentTransfer><feFuncA type="linear" slope="1.05" intercept="-0.05"/></feComponentTransfer></filter></svg>');

  place();
  renderAll();
  refresh(); // trae total y codigos reales del carrito
  loadUpsell();
  try { wideMQ.addEventListener('change', place); } catch (err) { try { wideMQ.addListener(place); } catch (e2) {} }
  if (pageType !== 'cart' && document.getElementById('mini-cart')) setTimeout(loadEstimator, 1500);

  var root = document.documentElement;
  root.addEventListener('cart:refresh', function (e) {
    if (e.detail && e.detail.cart && e.detail.cart.total_price !== undefined) {
      if (e.detail.cart.discount_codes) setCart(e.detail.cart); else setTotal(e.detail.cart.total_price);
    } else refresh();
  });
  ['variant:added', 'cart:updated', 'cart:change'].forEach(function (name) {
    root.addEventListener(name, refresh);
    document.addEventListener(name, refresh);
  });

  try {
    new PerformanceObserver(function (list) {
      var hit = list.getEntries().some(function (en) { return /\/cart\/(add|change|update|clear)/.test(en.name); });
      if (hit) refresh();
    }).observe({ type: 'resource', buffered: false });
  } catch (err) {}

  var placeQueued = false;
  new MutationObserver(function () {
    if (placeQueued) return;
    placeQueued = true;
    requestAnimationFrame(function () { placeQueued = false; place(); });
  }).observe(document.body, { childList: true, subtree: true });
})();
